export default "__VITE_ASSET__bqlCPsrQ__"